import React, { useState } from 'react';
import { observer } from "mobx-react";
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import {regionReportsTabDataStore} from '../../store/apiStores'
import { nameFromUrl } from '../../lib/strFormatting'

import RegionSummaryCovidSection from './RegionSummaryCovidSection'
import RegionSummaryAirQualitySection from './RegionSummaryAirQualitySection'
import RegionSummaryFiresSection from './RegionSummaryFiresSection'

const sectionStyle = {
    paddingTop: '20px'
}

export default function RegionSummary(props) {

    return (
        <div>
            <RegionSummaryHeader
                region={props.region}
                state={props.state}
                county={props.county}
                style={{paddingTop: '20px'}} />
            <Container fluid={true} style={{paddingTop: '40px'}}>
                <Row style={sectionStyle}>
                    <Col>
                        <RegionSummaryAirQualitySection
                            region={props.region}
                            state={props.state}
                            county={props.county}  />
                    </Col>
                </Row>
                {/*
                <Row style={sectionStyle}>
                    <Col>
                        <RegionSummaryFiresSection
                            region={props.region}
                            state={props.state}
                            county={props.county} />
                    </Col>
                </Row>
                */}
            </Container>
        </div>
    )
}

let RegionSummaryHeader = observer((props) => {
    let areaString = '';
    let county = nameFromUrl(props.county)
    let state = nameFromUrl(props.state)
    let region = nameFromUrl(props.region)
    if (county) {
        areaString = `${county}, ${state}`;
    } else if (state) {
        areaString = state;
    } else {
        areaString = `Entire ${region} ${(region != 'United States') ? 'Region' : ''}`;
    }
    let population = ''
    if (regionReportsTabDataStore.data) {
        population = (regionReportsTabDataStore.data.population)
            ? (regionReportsTabDataStore.data.population.toLocaleString())
            : ('n/a');
    }
    return (
        <div>
            <h2 style={props.style}>Summary Report for {areaString}</h2>
            <div>Population: {population}</div>
        </div>
    )
})
